import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo_icon.png'
import { MdClose, MdKeyboardArrowRight } from "react-icons/md";


export default function SideBar(props) {

  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({
      item,
    })

    if(appContext.isSideBarOpen) {
      closeSideBar();
    } else {
      //..
    }
  }

  const navItems = [
    { key: "home", label: "Home", active: !appContext.navItem || appContext.navItem === "home" },
    { key: "about_us", label: "About Us", active: appContext.navItem === "about_us" },
    { key: "services", label: "Services", active: appContext.navItem === "services" },
    { key: "contact_us", label: "Contact Us", active: appContext.navItem === "contact_us" },
  ];

  return (
    <div
      className="SideBar"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">
        <div className="web-sidebar-modern">
          <div className="web-sidebar-modern-head">
            <button className="web-sidebar-modern-close" onClick={closeSideBar} aria-label="Close menu">
              <MdClose size={22} />
            </button>
          </div>

          <div className="web-sidebar-modern-brand" onClick={() => goTo("home")}>
            <img src={logo} alt="Kinemo Logo" className="web-sidebar-modern-logo" />
            <div className="web-sidebar-modern-brand-copy">
              <p className="web-sidebar-modern-title">Kinemo Agro</p>
            </div>
          </div>

          <nav className="web-sidebar-modern-nav" aria-label="Main navigation">
            {navItems.map((item) => (
              <button
                key={item.key}
                className="web-sidebar-modern-item"
                data-active={item.active}
                onClick={() => goTo(item.key)}
              >
                <span className="web-sidebar-modern-item-label">{item.label}</span>
                <span className="web-sidebar-modern-item-icon">
                  <MdKeyboardArrowRight />
                </span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}
